export default {
  props: {},
  data() {
    return {
      invoiceTypeData: [],
    };
  },
  mounted() {
    this.getDicMap('invoice_class,invoice_type', () => {
      this.initInvoiceTypeData();
    });
  },
  methods: {
    // 组合开票类型数据
    initInvoiceTypeData() {
      /**
       * 新发票类型             旧发票类型       invoiceType      invoiceClass
       * 增值税专用发票（电子）  增值税专用发票    special(2)          electronic
       * 增值税专用发票（纸质）  增值税专用发票    special(2)          paper
       * 普通发票（电子）        增值税普通发票    normal(1)           electronic
       * 普通发票（纸质）        增值税普通发票    normal(1)         paper
       * 专用发票（电子）        专用发票         electron(3)          electronic
       * 专用发票（纸质）        专用发票         electron(3)          paper
       */
      const data = [
        {
          name: this.$t('Common.com_minxins_zzszyfpdz'),
          invoiceType: 'special',
          invoiceClass: 'electronic',
        },
        {
          name: this.$t('Common.com_minxins_zzszyfpzz'),
          invoiceType: 'special',
          invoiceClass: 'paper',
        },
        {
          name: this.$t('Common.com_minxins_ptfpdz'),
          invoiceType: 'nomal',
          invoiceClass: 'electronic',
        },
        {
          name: this.$t('Common.com_minxins_ptfpzz'),
          invoiceType: 'nomal',
          invoiceClass: 'paper',
        },
      ];
      const invoiceType = this.dicMap.invoice_type;
      const invoiceClass = this.dicMap.invoice_class;
      data.forEach((item) => {
        item.invoiceTypeValue = `${invoiceType[item.invoiceType]}`;
        item.invoiceClassValue = `${invoiceClass[item.invoiceClass]}`;
        item.value = [item.invoiceTypeValue, item.invoiceClassValue].join('_');
      });
      this.invoiceTypeData = data;
    },
    // 获取value对应的对象
    getItem(value) {
      return this.invoiceTypeData.find((item) => item.value === `${value}`);
    },
    // 根据invoiceType 和 invoiceClass获取对应的对象
    getItemByTypeAndClass(invoiceType, invoiceClass) {
      return this.invoiceTypeData.find((item) => item.invoiceTypeValue === `${invoiceType}` && item.invoiceClassValue === `${invoiceClass}`);
    },
    updateTypeAndClassByValue(context, value) {
      const val = value ? value.split('_') : ['', ''];
      context.invoiceType = val[0];
      context.invoiceClass = val[1];
    },
    initTypeAndClassByValue(context, value) {
      const val = value ? value.split('_') : ['', ''];
      context.invoiceType = context.invoiceType || val[0];
      context.invoiceClass = context.invoiceClass || val[0];
    },
    // 根据invoiceType, invoiceClass 返回对应的中文
    getItemNameByTypeAndClass(invoiceType, invoiceClass) {
      if (this.invoiceTypeData && this.invoiceTypeData.length) {
        const item = this.getItemByTypeAndClass(invoiceType, invoiceClass);
        return item ? item.name : '';
      }
      return '';
    },
    // 给tableColumn添加 发票类别 列
    headerListAddInvoiceClass(headerList) {
      const spliceIndex = headerList.findIndex((item) => item.columnCode === 'invoiceType');
      if (spliceIndex >= 0) {
        headerList.splice(spliceIndex, 0, {
          columnCode: 'invoiceClass',
          columnName: '发票类别',
          dicGroup: 'invoice_class',
          isFormat: 1,
        });
      }
    },
  },
};
